import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoginService } from '../Service/login.service';
import { AlertService } from '../Service/alert.service'; // ✅ Importar AlertService

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private sessionExpiredShown = false;

  constructor(
    private router: Router,
    private loginService: LoginService,
    private alertService: AlertService // ✅ Inyectar AlertService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.loginService.getToken();
    let clonedRequest = req;

    if (token && !this.isPublicEndpoint(req.url)) {
      clonedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      console.log('🔐 Token agregado a request:', req.url);
    }

    return next.handle(clonedRequest).pipe(
      tap((event: HttpEvent<any>) => {
        // ✅ Agregar log para respuestas exitosas
        if (event instanceof HttpResponse) {
          console.log('✅ Request exitoso:', req.url, '| Status:', event.status);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        // ✅ Log detallado del error
        console.log('❌ Error en request:', {
          url: req.url,
          status: error.status,
          message: error.message,
          timestamp: new Date().toISOString()
        });

        if (error.status === 401 && !this.sessionExpiredShown) {
          console.error('🚨 401 Unauthorized - Sesión expirada en:', req.url);
          console.log('🔍 Verificando estado de usuario - Token inválido o expirado');
          this.handleSessionExpired();
        }
        return throwError(() => error);
      })
    );
  }

  private isPublicEndpoint(url: string): boolean {
    const publicEndpoints = [
      '/auth/login',
      '/auth/adminLogin',
      '/', '/home', '/home2', '/djnr', '/landing', '/safyc'
    ];
    return publicEndpoints.some(endpoint => url.includes(endpoint));
  }

  private handleSessionExpired(): void {
    if (this.sessionExpiredShown) {
      console.log('⚠️ Alerta de sesión expirada ya mostrada, ignorando...');
      return;
    }
    this.sessionExpiredShown = true;

    console.log('🚪 Cerrando sesión por token expirado...');
    console.log('🔍 Usuario activo: FALSE - Iniciando logout');

    this.alertService.showAlert(
      'error',
      'Su sesión ha expirado. Por favor, inicie sesión nuevamente.',
      () => {
        console.log('✅ Usuario confirmó cierre de sesión');
        this.loginService.logout();

        setTimeout(() => {
          this.sessionExpiredShown = false;
          console.log('🔄 Flag de sesión expirada reseteado');
        }, 2000);
      },
      () => {}
    );
  }
}
